import { useQuery } from '@tanstack/react-query';
import { Card, MultiSelect } from 'corso-admin-ui';
import { isTruthy } from 'corso-types';
import { Controller, useFormContext } from 'react-hook-form';
import api from '~/api';
import type { PlatformSettings } from './PlatformPage';

export function FrontSettingsCard() {
  const { control } = useFormContext<PlatformSettings>();

  const { data: tags } = useQuery({
    queryKey: ['front-tags'],
    queryFn: () => api.frontTags.list(),
    select: (data) => [...data].sort((a, b) => a.name.localeCompare(b.name)),
  });

  return (
    <Card>
      <Card.Heading>Front reports</Card.Heading>

      <Controller
        control={control}
        name="frontReportTags"
        render={({ field: { onChange, value }, fieldState }) => (
          <MultiSelect
            label="Front tags"
            placeholder="Search for a front tag"
            options={
              tags?.map((tag) => ({
                label: (
                  <div className="flex flex-col gap-1">
                    {tag.name}
                    {tag.description && (
                      <p className="text-xs text-neutral-500">
                        {tag.description}
                      </p>
                    )}
                  </div>
                ),
                keywords: [tag.name, tag.description ?? ''],
                value: tag.id,
              })) ?? []
            }
            value={value.map((tag) => ({ label: tag.name, value: tag.id }))}
            onChange={(selected) =>
              onChange(
                selected
                  .map(({ value: tagId }) => tags?.find((t) => t.id === tagId))
                  .filter(isTruthy),
              )
            }
            details="Front tags to include when generating monthly reports."
            error={fieldState.error?.message}
          />
        )}
      />
    </Card>
  );
}
